<template>
    <section class="card-product-informations">
        <h2 v-if="customTitleCode" v-html="translate(customTitleCode)"/>
        <h2 v-else-if="data.title" v-html="translate(data.title)"/>

        <div v-if="data.values" class="elements-container">

            <div v-for="element in parsedData" class="element accessory-element" v-if="!element.isDisabled">

                <template v-if="element.submenu !== undefined">


                    <span class="title" v-html="translate(element.title)"/>

                    <template v-if="!isEditable">
                        <span v-if="element.title" class="value"
                              v-html="getValue(element.title)"/>
                    </template>

                    <corrosion_protection_editable_property_value
                            v-else
                            :initialData="element.values"
                            :defaultKey="getDefaultValueKey()"
                            :elementKey="element.title"
                            :connectedKey="element.connectedKey"
                            :selectedKey="getSelectedValueKey(element.title)"/>

                </template>
                <template v-if="element.submenu === undefined">
                    <span v-if="element.title" class="title" v-html="translate(element.title)"/>
                    
                    <span v-if="element.value && element.translation && element.title != 'coating_thickness'" class="value" v-html="translate(element.value)"/>
                    <span v-else-if="element.value && element.title != 'coating_thickness'" class="value" v-html="element.value"/>
                    <div v-if="element.values">
                        <div v-for="sub_element in element.values" class="sub_element" v-if="sub_element.isActive">
                            <span :style="{'visibility':(sub_element.isActive?'':'hidden')}" class="icon-ok"/>
                            <span class="value" v-html="translate(sub_element.title)"/>
                        </div>
                    </div>

                    <span class="value one-line" v-if="element.title == 'coating_thickness'">
                        <span v-if="!coating_thickness_edit || !isAdmin" v-html="element.value" @click="coating_thickness_edit = true"/>
                        <input type="text" @blur="coating_thickness_edit = false" v-else class="edit-input" v-model="$store.state.productCard['custom'].corrosion_protection.values.coating_thickness.value">
                    </span>
                </template>
            </div>
        </div>

    </section>
</template>

<script>
    import corrosion_protection_editable_property_value from "../offers/corrosion_protection_editable_property_value";
    // NVS-152
    export default {
        name: "corrosionProtection",
        components: {corrosion_protection_editable_property_value},
        props: ['data', 'custom-title-code'],
        data() {
            return {
                coating_thickness_edit: false
            }
        },
        methods: {
            translate(code, displayErrors = true) {
                let arg = {
                    type: 'translate',
                    code: code,
                    displayErrors: displayErrors,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },
            getSelectedValueKey(code) {
                if(this.getCustomAntiCorrosion.hasOwnProperty(code) && this.getCustomAntiCorrosion[code].value != '-') return this.getCustomAntiCorrosion[code].value
            },
            getDefaultValueKey() {
                return this.getAntiCorrosion.find(x => x.is_standard == 1).id;
            },
        },
        computed: {
            parsedData() {
                let modifiedData = this.data.values

                if (modifiedData.hasOwnProperty('class_category')) {
                    modifiedData.class_category.values = this.getAntiCorrosion.map(el => { return { id: el.id, value: el.class, connectedValue: el.coating, surcharge: el.surcharge_code} })
                }
                return modifiedData
            },
            isEditable() {
                if(this.$store.getters.getUserRole !== 'admin') return false;
                return this.$store.getters.isOfferEditable;
            },

            getValue() {
                return function (code) {
                    let value = this.getCustomAntiCorrosion[code].value
                    if(value != '-') value = this.getCustomAntiCorrosion[code].values.find(el => el.id == value).value
                    if(code == 'class_category') {
                        value = value || this.getAntiCorrosion.find(x => x.is_standard == 1).class;
                    }
                    return value;
                }
            },

            getAntiCorrosion() {
                return this.$store.state.offerAntiCorrosion
            },

            getCustomAntiCorrosion() {
                return this.$store.state.productCard['custom'].corrosion_protection.values
            },

            isAdmin() {
                return this.$store.getters.getUserRole == 'admin'
            },
        },
    }
</script>